<template>
    <div :class="['patient', {
        corrected: patient.selectedProfile,
        error: !patient.selectedProfile
    }]">
        <div class="account">
			<span class="name">
				<strong>{{ patient.data.name }}</strong>
				<template v-if="patient.data.email">
					<br><div class="extra-info">{{ patientProviderNames }} </div>
				</template>
                <template v-if="patient.data.phone || patient.data.email">
					<br>
					<small> 
						<template v-if="patient.data.email"> {{ patient.data.email }}</template>
						{{ patient.data.phone && patient.data.email ?  ',' : ''}}
						<template v-if="patient.data.phone">{{ patient.data.phone }}</template>
					</small>
				</template>
			</span>
            <!--
                Choosing profile for 
            -->
            <!-- <ol class="events" :class="unprofiledEvents.length > 1 ? 'multiple' : 'single'">
                <li class="event" v-for="event in unprofiledEvents" :key="event.row">
                    <el-select
                        @change="changeProfile($event, event.row)"
                        v-model="profile"
                        placeholder="Select Profile"
                        size="small">
                        <el-option v-for="profile in getProfileList(event.provider)"
                            :key="profile.id"
                            :label="profile.title"
                            :value="profile.id">
                        </el-option>
                    </el-select>
                    <el-button type="text" class="edit-button" @click="removeProfile()" v-if="profile">
                        <EditIcon></EditIcon> Edit
                    </el-button>
                </li>
            </ol> -->
        </div>
        <ImportData
			:patient="patient"
			:column="column"
			:highlight="['email','date', 'time', 'event', 'code', 'doctor']"
            :show-patient="unprofiledEvents">
		</ImportData>
    </div>
</template>

<script>
import ImportPatientRow from '.'
import { mapGetters } from 'vuex'

export default {
    name: 'import-patient-profile-row',
    extends: ImportPatientRow,
    data() {
        return {
            profile: null
        }
    },
    methods: {
        /**
         * Emits an events to update the profile for the patient
         * 
         * @param {String} profile Chosen profile for the patient
         */
        changeProfile(chosenProfile, row) {
            console.log(chosenProfile, row)
            // Update profile to chosen profile
            if(chosenProfile && chosenProfile !== '')
                this.$emit('update-profile', { chosenProfile, row })
            // Set profile to null if reseting
            else
                this.$emit('update-profile')
        },
        removeProfile() {
            this.profile = ''
            this.changeProfile('')
        },
        getProfileList(inputProvider) {
            if(this.getProviderList) {
                const currentProvider = this.getProviderList.find((provider) => provider.provider === inputProvider)
                if(currentProvider)
                    return currentProvider.profile
            }
            return []
        }
    },

    computed: {
        ...mapGetters('provider', [ 'getProviderList' ]),
        profileList() {
            if(this.getProviderList) {
                const currentProvider = this.getProviderList.find((provider) => provider.provider === this.patient.data.provider)
                if(currentProvider)
                    return currentProvider.profile
            }
            return []
        },
        unprofiledEvents() {
            try {
                return this.patient.data.event.filter((event) => !event.profile)
            } catch (error) {
                console.error('Error checking unprofiled events', error)
                return this.patient.data.event
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";

</style>